export const addNotes = {
  type:'',
  description: '',
  start_date: null,
  end_date: null,
}
export const NotesHd = [
  { label: 'Type', sortOption: false},
  { label: 'Description', sortOption: false },
  { label: 'Details', sortOption: false },
  { label: 'Start Date', sortOption: false },
  { label: 'End Date', sortOption: false },
  { label: 'Action', sortOption: false },
];
export const errorCode = {
  description:{
    0:'',
    1: 'Please enter Description'
  },
  descriptionObj: {
    required: true
  }
}
